/**
 * Adjuntos de pago
 *
 */
import React from 'react'
import { Button, Modal, message, Dropdown, Menu, Form, InputNumber, Row, Col, Skeleton, DatePicker } from 'antd'
import Api from '../../../Api'
import Exception from '../../../Exception'
import { connect } from 'react-redux'

class Info extends React.Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props)

    this.emptyData = {
      iId: -2,
      iIdMoneda: -2,
      dTipoCambio: 0.0,
      dIva: 0.0,
      iMontoIVA: 0.0,
      dDescuento: 0.0,
      dMontoSeguro: 0.0,
      iPorcentajeDescuento: false,
      dFechaVigencia: null,
    }

    this.state = {
      data: {
        ...this.emptyData
      },
      loading: false,
      cotizacionId: 0,
      cotizacionPendiente: false,
      monedas: [],
    }
  }

  /**
   * Load
   *
   * @param {Number} cotizacionId
   */
  load = (cotizacionId) => {
    this.setState({
      visible: true,
      loading: true,
      data: { ...this.emptyData },
      cotizacionId: cotizacionId,
    })

    const query = {
      info: {
        __returnType: 'one',
        model: 'ComCuadroComparativoProveedor',
        attributes: Object.keys(this.emptyData),
        include: [{ as: 'moneda', attributes: [['sNombre', 'nombre']] }],
        where: {
          iIdCuadro: cotizacionId,
          iIdProveedor: Api.getProviderId(),
          iActivo: true
        },
      },

      firmas: {
        model: 'ComCuadroComparativoFirma',
        attributes: ['iId'],
        where: {
          iIdCuadro: cotizacionId,
          iIdUsuario: { $gt: 0 },
          iActivo: true,
        },
        limit: 1,
      },

      monedas: {
        model: 'AlmMoneda',
        attributes: [
          ['iId', 'key'],
          ['sNombre', 'nombre'],
          ['sIdFix', 'fix'],
          ['sIdFix', 'fix'],
          ['iLocal', 'local']
        ],
        where: {
          iActivo: true,
        }
      }
    }

    Api.query.list(query)
      .then(response => {
        this.setState({
          data: response.data.info,
          monedas: response.data.monedas || [],
          cotizacionPendiente: response.data.firmas.length === 0,
        })

        this.props.form.setFieldsValue(response.data.info)
        return Api.get('/com/divisas/banxico')
      })
      .then(({ data: divisas = [] }) =>
        this.setState({
          loading: false,
          monedas: this.state.monedas.map(moneda => {
            const divisa = divisas.find(d => d.id === moneda.fix)
            return {
              ...moneda,
              fix: divisa ? divisa.valor : (moneda.local ? 1 : 0)
            }
          })
        })
      )
      .catch(error => {
        this.setState({ loading: false })
        Exception.load(error).show()
      })
  }

  /**
   * save
   */
  save = () => {
    const closeLoading = message.loading('Guardando...', 0)
    this.setState({ loading: true })

    Api.put(`/com/cotizaciones/cotizacion/${this.state.data.iId}`, this.props.form.getFieldsValue())
      .then(() => {
        this.setState({ loading: false, visible: false })
        closeLoading()
        message.success('Guardado')
      })
      .catch(error => {
        this.setState({ loading: false })
        Exception.load(error).show()
        closeLoading()
      })
  }

  getField = (name) => {
    const form = this.props.form
    const fields = {
      /**
       * Moneda
       */
      iIdMoneda: form.getFieldDecorator(name, { rules: [{ required: true, message: 'Moneda' }] })(
        <Dropdown.Button
          overlay={
            <Menu
              children={this.state.monedas.map(moneda =>
                <Menu.Item key={moneda.key.toString()}>{moneda.nombre}</Menu.Item>
              )}
              onClick={e => {
                const moneda = this.state.monedas.find(moneda => moneda.key.toString() === e.key)
                form.setFieldsValue({
                  [name]: e.key,
                  dTipoCambio: moneda.fix,
                })

                this.setState({
                  data: {
                    ...this.state.data,
                    moneda: moneda
                  }
                })
              }}
            />
          }
          children={this.state.data.moneda ? this.state.data.moneda.nombre : 'MONEDA'}
        />
      ),

      /**
       * Tipo de cambio
       */
      dTipoCambio: form.getFieldDecorator(name, { rules: [{ required: true, message: 'Tipo de cambio (FIX)' }] })(
        <InputNumber
          placeholder='FIX'
        />
      ),

      /**
       * Descuento en porcentaje
       */
      iPorcentajeDescuento: form.getFieldDecorator(name, { rules: [{ required: true }] })(
        <Dropdown.Button
          overlay={
            <Menu
              children={[
                <Menu.Item key={'1'}>SI</Menu.Item>,
                <Menu.Item key={'0'}>NO</Menu.Item>
              ]}
              onClick={e => {
                form.setFieldsValue({ [name]: e.key })
              }}
            />
          }
          children={form.getFieldValue(name) === '1' ? 'SI' : 'NO'}
        />
      ),

      /**
       * Descuento
       */
      dDescuento: form.getFieldDecorator(name, { rules: [{ required: true, message: 'Descuento' }] })(
        <InputNumber placeholder='DESCUENTO' />
      ),

      /**
       * IVA en monto
       */
      iMontoIVA: form.getFieldDecorator(name, { rules: [{ message: 'Iva en monto' }] })(
        <Dropdown.Button
          overlay={
            <Menu
              children={[
                <Menu.Item key={'1'}>SI</Menu.Item>,
                <Menu.Item key={'0'}>NO</Menu.Item>
              ]}
              onClick={e => {
                form.setFieldsValue({ [name]: e.key })
              }}
            />
          }
          children={form.getFieldValue(name) === '1' ? 'SI' : 'NO'}
        />
      ),

      /**
       * IVA
       */
      dIva: form.getFieldDecorator(name, { rules: [{ required: true, message: 'IVA' }] })(
        <InputNumber placeholder='IVA' />
      ),

      /**
       * Seguro
       */
      dMontoSeguro: form.getFieldDecorator(name, { rules: [{ required: true, message: 'Seguro' }] })(
        <InputNumber
          placeholder='SEGURO'
        />
      ),

      dFechaVigencia: form.getFieldDecorator(name, { rules: [{ required: true, message: 'Fecha de vigencia' }] })(
        <DatePicker
          placeholder='FECHA DE VIGENCIA'
        />
      ),
    }

    return fields[name]
  }

  /**
   * Render
   *
   */
  render() {
    return (
      <Modal
        title='INFORMACIÓN GENERAL'
        visible={this.state.visible}
        onOk={this.onSave}
        style={{ minWidth: 300, width: 300 }}
        onCancel={() => this.setState({ visible: false })}
        footer={[
          <Button
            key='close'
            loading={this.state.loading}
            onClick={() => this.setState({ visible: false })}
            children='CERRAR'
          />
        ].concat(this.state.cotizacionPendiente ? [
          <Button
            key='save'
            loading={this.state.loading}
            onClick={this.save}
            children='ACEPTAR'
            type='primary'
          />
        ] : [])}
        children={
          <Skeleton loading={this.state.loading}>
            <Form onSubmit={this.onSubmitForm}>
              <Row>
                <h3>Moneda</h3>
                <Col span={8}>
                  <Form.Item
                    label={<label>MONEDA</label>}
                    children={this.getField('iIdMoneda')}
                  />
                </Col>

                <Col span={4}>
                  <Form.Item
                    label={<label>TIPO DE CAMBIO (FIX)</label>}
                    children={this.getField('dTipoCambio')}
                  />
                </Col>
              </Row>

              <Row>
                <h3>Descuento</h3>
                <Col span={8}>
                  <Form.Item
                    label={<label>APLICA EN PORCENTAJE</label>}
                    children={this.getField('iPorcentajeDescuento')}
                  />
                </Col>
                <Col span={4}>
                  <Form.Item
                    label={<label>DESCUENTO {this.props.form.getFieldValue('iPorcentajeDescuento') === '1' ? '%' : '$'}</label>}
                    children={this.getField('dDescuento')}
                  />
                </Col>
              </Row>

              <Row>
                <h3>IVA</h3>
                <Col span={8}>
                  <Form.Item
                    label={<label>IVA EN MONTO</label>}
                    children={this.getField('iMontoIVA')}
                  />
                </Col>
                <Col span={4}>
                  <Form.Item
                    label={<label>IVA {this.props.form.getFieldValue('iMontoIVA') === '1' ? '$' : '%'}</label>}
                    children={this.getField('dIva')}
                  />
                </Col>
              </Row>

              <Row>
                <h3>Seguro</h3>
                <Col span={8}>
                  <Form.Item
                    label={<label>SEGURO $</label>}
                    children={this.getField('dMontoSeguro')}
                  />
                </Col>

                <Col span={10}>
                  <Form.Item
                    label={<label>FECHA DE VIGENCIA</label>}
                    children={this.getField('dFechaVigencia')}
                  />
                </Col>
              </Row>
            </Form>
          </Skeleton>
        }
      />
    )
  }
}

const connectedComponent = connect(
  state => ({
    theme: state.theme.values,
  }),
  undefined,
  undefined,
  { forwardRef: true },
)(Info)

const InfoForm = Form.create({ withRef: true })(connectedComponent)
export default InfoForm
